import { ContentComponent } from "./content";
import { Root } from "./root";
import { SubtitleComponent } from "./subtitle";
import { TitleComponent } from "./title";

export const CardComponent = {
  Root,
  Content: ContentComponent,
  Title: TitleComponent,
  Subtitle: SubtitleComponent,
};
